import { FlowValueTypeMap } from "../../../constants/modules/dataType";
import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
} from "@packages/flow-core/module";
import { DetailedHTMLProps, HTMLAttributes } from "react";
import styles from "./index.less";
import { Tooltip } from "antd";
import { Connection, Handle, Position } from "reactflow";
import { useFlow } from "../FlowEdit/useFlow";

interface ToolHandleProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  moduleId: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ToolTargetHandle({ moduleId, ...props }: ToolHandleProps) {
  const valueTypeMap = FlowValueTypeMap[ModuleIOValueTypeEnum.tools];

  return (
    <div className={styles.container} {...props}>
      <Tooltip
        title={
          <div>
            <div>{valueTypeMap.label}</div>
            {valueTypeMap.description && <div>{valueTypeMap.description}</div>}
          </div>
        }
      >
        <Handle
          style={{
            width: 14,
            height: 14,
            border: "4px solid #5E8FFF",
            borderRadius: 0,
            backgroundColor: "transparent",
            transformOrigin: "center",
            transform: "rotate(45deg)",
          }}
          id={ModuleOutputKeyEnum.selectedTools}
          position={Position.Top}
          type="target"
        />
      </Tooltip>
    </div>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ToolSourceHandle({ moduleId, ...props }: ToolHandleProps) {
  const valueTypeMap = FlowValueTypeMap[ModuleIOValueTypeEnum.tools];
  const { getAllNodes, setEdges } = useFlow();

  const onConnect = (e: Connection) => {
    const node = getAllNodes().find((node) => node.id === e.target);
    if (!node) return;
    const inputs = node.data.inputs;
    setEdges((edges) => {
      return edges.filter((edge) => {
        const input = inputs.find((input) => input.key === edge.targetHandle);
        if (
          edge.target === node.id &&
          (!!input?.toolDescription || input?.key === ModuleInputKeyEnum.switch)
        ) {
          return false;
        }
        return true;
      });
    });
  };

  return (
    <div className={styles["source-container"]} {...props}>
      <Tooltip
        title={
          <div>
            <div>{valueTypeMap.label}</div>
            {valueTypeMap.description && <div>{valueTypeMap.description}</div>}
          </div>
        }
      >
        <Handle
          style={{
            width: 14,
            height: 14,
            border: "4px solid #5E8FFF",
            borderRadius: 0,
            backgroundColor: "transparent",
            transformOrigin: "center",
            transform: "rotate(45deg)",
          }}
          id={ModuleOutputKeyEnum.selectedTools}
          position={Position.Bottom}
          type="source"
          onConnect={onConnect}
        />
      </Tooltip>
    </div>
  );
}
